import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { usePartner } from '../../helpers/BrandPageAPI';

const CategoryShow = () => {
    const { partnerData } = usePartner();
    const customerStore = useParams();
    const navColor = partnerData?.StoreColor || "#d4af37";
    const customerLink = customerStore?.UserCode;

    return (
        <div className='category_shop'>
            <div className="container-xxl mt-5">
                <div className="category-title">
                    <h2>Shop by Categories</h2>
                </div>
                <div className='category_shop_grid'>
                    {Array.isArray(partnerData?.Categories) && partnerData.Categories.length > 0 &&
                        partnerData.Categories.map((category, index) => (
                            <div className='category_gallary' key={index}>
                                <div className="category_gallary_img">
                                    {/* <img
                                        src="https://www.tanishq.co.in/on/demandware.static/-/Library-Sites-TanishqSharedLibrary/default/dw770a9bca/homepage/tanishq-pillars/tw-nt-wedding-desktop.jpg"
                                        alt="category_img"
                                    /> */}
                                    <Link
                                        to={`/${customerLink}/category/${category.GatiCategoryId}`}
                                        style={{ color: navColor, textAlign: "center", paddingTop: "15px" }}
                                    >
                                        {category.DesgGroupName}
                                    </Link>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        </div>
    )
}

export default CategoryShow